module.exports = __webpack_public_path__ + "img/product3.4d61ed89.png";